declare namespace $ {

	type $mol_button_minor__attr_shm_hitalama_map_catalog_1 = $mol_type_enforce<
		({ 
			'favorite': ReturnType< $shm_hitalama_map_catalog['map_favorite'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		,
		ReturnType< $mol_button_minor['attr'] >
	>
	type $mol_button_minor__hint_shm_hitalama_map_catalog_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['favorite_hint'] >
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__event_click_shm_hitalama_map_catalog_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['favorite_toggle'] >
		,
		ReturnType< $mol_button_minor['event_click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_catalog_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__attr_shm_hitalama_map_catalog_5 = $mol_type_enforce<
		({ 
			'favorite': ReturnType< $shm_hitalama_map_catalog['map_favorite'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_shm_hitalama_map_catalog_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__attr_shm_hitalama_map_catalog_7 = $mol_type_enforce<
		({ 
			'editor': ReturnType< $shm_hitalama_map_catalog['editor_mode_current'] >,
		})  & ReturnType< $mol_link['attr'] >
		,
		ReturnType< $mol_link['attr'] >
	>
	type $mol_link__hint_shm_hitalama_map_catalog_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['hint'] >
	>
	type $mol_link__sub_shm_hitalama_map_catalog_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_link__arg_shm_hitalama_map_catalog_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['editor_mode_link'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_view__attr_shm_hitalama_map_catalog_11 = $mol_type_enforce<
		({ 
			'editor': ReturnType< $shm_hitalama_map_catalog['editor_mode_current'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_shm_hitalama_map_catalog_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_dimmer__needle_shm_hitalama_map_catalog_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['menu_filter'] >
		,
		ReturnType< $mol_dimmer['needle'] >
	>
	type $mol_dimmer__haystack_shm_hitalama_map_catalog_14 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['spread_title'] >
		,
		ReturnType< $mol_dimmer['haystack'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_catalog_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_catalog_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['add_map'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_catalog_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_catalog_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['add_map'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_catalog_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_catalog_20 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['add_map'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_catalog_21 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $shm_hitalama_attach__attach_title_shm_hitalama_map_catalog_22 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_attach['attach_title'] >
	>
	type $shm_hitalama_attach__attach_new_shm_hitalama_map_catalog_23 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['import'] >
		,
		ReturnType< $shm_hitalama_attach['attach_new'] >
	>
	type $mol_list__sub_shm_hitalama_map_catalog_24 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['sub'] >
	>
	type $mol_pop_over__align_shm_hitalama_map_catalog_25 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pop_over['align'] >
	>
	type $mol_pop_over__Anchor_shm_hitalama_map_catalog_26 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['Add_map_anchor'] >
		,
		ReturnType< $mol_pop_over['Anchor'] >
	>
	type $mol_pop_over__bubble_content_shm_hitalama_map_catalog_27 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pop_over['bubble_content'] >
	>
	type __shm_hitalama_map_catalog_28 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_catalog['sort_order'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_catalog['List_head'] >['sort_order'] >[0]
	>
	type $shm_list_head__title_shm_hitalama_map_catalog_29 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['menu_title'] >
		,
		ReturnType< $shm_list_head['title'] >
	>
	type $shm_list_head__add_content_shm_hitalama_map_catalog_30 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_list_head['add_content'] >
	>
	type $shm_list_head__close_shm_hitalama_map_catalog_31 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['close_maps_list'] >
		,
		ReturnType< $shm_list_head['close'] >
	>
	type $shm_list_head__filter_shm_hitalama_map_catalog_32 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['menu_filter'] >
		,
		ReturnType< $shm_list_head['filter'] >
	>
	type $shm_list_head__sort_by_shm_hitalama_map_catalog_33 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['sort_by'] >
		,
		ReturnType< $shm_list_head['sort_by'] >
	>
	type $shm_hitalama_map_page__entity_shm_hitalama_map_catalog_34 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['entity'] >
		,
		ReturnType< $shm_hitalama_map_page['entity'] >
	>
	type $shm_hitalama_map_book__entity_shm_hitalama_map_catalog_35 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['entity'] >
		,
		ReturnType< $shm_hitalama_map_book['entity'] >
	>
	type $shm_hitalama_map_catalog_menu_link_content__36 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['public_icon_visible'] >[number]
		,
		$mol_view_content
	>
	type $mol_view__sub_shm_hitalama_map_catalog_37 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_catalog['map_menu_links'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_map_catalog extends $shm_hitalama_entity_catalog {
		map_favorite( id: any): boolean
		favorite_hint( id: any): string
		favorite_toggle( id: any, next?: any ): any
		Favorite_icon( id: any): $mol_icon_star
		Favorite( id: any): $mol_button_minor
		Favorite_action( id: any): $mol_view
		editor_mode_current( id: any): boolean
		Editor_mode_icon( id: any): $mol_icon_code_braces
		editor_mode_link( id: any): Record<string, any>
		Editor_mode( id: any): $mol_link
		Editor_mode_action( id: any): $mol_view
		Public_icon( id: any): $mol_icon_earth
		public_icon_visible( id: any): readonly(any)[]
		Menu_link_title( id: any): $mol_dimmer
		map_menu_links( ): readonly($mol_view)[]
		Add_map_icon( ): $mol_icon_plus
		Add_map_anchor( ): $mol_button_minor
		add_map( id: any): any
		Add_private_icon( ): $mol_icon_plus
		Add_private( ): $mol_button_minor
		Add_public_icon( ): $mol_icon_plus
		Add_public( ): $mol_button_minor
		Add_public_edit_icon( ): $mol_icon_plus
		Add_public_edit( ): $mol_button_minor
		import( next?: any ): any
		Import( ): $shm_hitalama_attach
		Add_map_menu( ): $mol_list
		Add_map( ): $mol_pop_over
		close_maps_list( next?: any ): any
		menu_filter( next?: string ): string
		sort_order( next?: ReturnType< ReturnType< $shm_hitalama_map_catalog['List_head'] >['sort_order'] > ): ReturnType< ReturnType< $shm_hitalama_map_catalog['List_head'] >['sort_order'] >
		sort_by( next?: string ): string
		List_head( ): $shm_list_head
		menu_title( ): string
		maps_list_visible( next?: boolean ): boolean
		param( ): string
		title_default( ): string
		Page( id: any): $shm_hitalama_map_page
		Book( id: any): $shm_hitalama_map_book
		menu_item_content( id: any): readonly($mol_view)[]
		menu_link_content( id: any): readonly($mol_view_content)[]
		menu_body( ): readonly(any)[]
		Map_menu_links( ): $mol_view
		menu_head( ): readonly($mol_view_content)[]
	}
	
}

//# sourceMappingURL=catalog.view.tree.d.ts.map